<template>
  <div>
    <div class="row" style="margin-bottom: -25px">
      <div class="col-md-12">
        <tickets-filter :employees="employees"
                        @get-tickets="getTickets"></tickets-filter>
        <progress-bar></progress-bar>
      </div>
    </div>
    <div class="row" v-if="(isTickets && isEmployees)">
      <div class="col-md-12">
        <tickets-list :employees="employees" :tickets="tickets" @update="updateTicket"></tickets-list>
      </div>
    </div>
    <div class="row" v-else>
      <div class="col-md-12" v-if="showEmpty">
        <base-button disabled simple block type="warning">
          There are no tickets
        </base-button>
      </div>
    </div>
  </div>
</template>

<script>
    import axios from "axios";
    import {getCookie, setCookie, url} from "../plugins/axios";
    import NotificationTemplate from "./Notifications/NotificationTemplate";
    import TicketsList from "./Tickets/TicketsList";
    import TicketsFilter from "../components/Filters/TicketsFilter";
    import ProgressBar from "../components/Progress";

    export default {
      name: "Tickets",
      components: {ProgressBar, TicketsFilter, TicketsList},
      data() {
        return {
          isTickets : false,
          isEmployees: false,
          showEmpty: false,
          tickets : [],
          employees: [],
          myEmployeeId: parseInt(getCookie('Employee-id')),
        };
      },
      methods: {
        notifyVue(type,message) {
          this.$notify({
            component: NotificationTemplate,
            icon: "tim-icons icon-bell-55",
            horizontalAlign: 'center',
            verticalAlign: 'top',
            type: type,
            message:message,
            timeout: 1500
          });
        },
        async getTickets(params){
          this.showEmpty = false;
          this.isTickets = false;
          this.tickets = [];
          await axios
            .post(url + 'tickets/',
              {data: params},
              {
                withCredentials:'include',
                crossDomain:true
              })
            .then((response) => {
              if (response.data.error === ''){
                this.tickets = response.data.result;
                this.isTickets = (this.tickets !== null);
                this.showEmpty = true;
              }
              else{
                if (response.data.error === 'Session is over'){
                  setCookie('Authentication','Failed',1);
                  this.$router.push('/login');
                }
                else{
                  this.notifyVue('danger',response.data.error);
                }
              }
            })
        },
        async getEmployees(){
          await axios
            .get(url + 'employees-short/',
              {
                withCredentials:'include',
                crossDomain:true
              })
            .then((response) => {
              if (response.data.error === ''){
                this.employees = response.data.result;
              }
              else{
                if (response.data.error === 'Session is over'){
                  setCookie('Authentication','Failed',1);
                  this.$router.push('/login');
                }
                else{
                  this.notifyVue('danger',response.data.error);
                }
              }
            })
            .catch((error) => {
              this.notifyVue('danger',error);
            });
        },
        updateTicket(ticket, action){
          let index = 0;
          for (let i in this.tickets){
            if (this.tickets[i]['ticket_id'] === ticket['ticket_id']){
              index =  i;
              break;
            }
          }
          let mutate = false;
          for (let param in ticket){
            this.tickets[index][param] = ticket[param];
            mutate = (param === 'is_delete') || mutate;
          }
          this.tickets = JSON.parse(JSON.stringify(this.tickets));
          const data = [];
          data[0] = ticket;
          axios
            .put(url + 'update-tickets/',
              {data: data},
              {
                withCredentials:'include',
                crossDomain:true
              })
            .then((response) => {
              if (response.data.error === ''){
              }
              else{
                if (response.data.error === 'Session is over'){
                  setCookie('Authentication','Failed',1);
                  this.$router.push('/login');
                }
                else{
                  this.notifyVue('danger',response.data.error);
                }
              }
            })
          const cTime = new Date();
          const comment = {
            comment_id : 0,
            ticket_id : this.tickets[index]['ticket_id'],
            employee_id: 0,
            date: cTime.getFullYear() + '-' + (cTime.getMonth() + 1) + '-' + (cTime.getDate()) + ' ' + cTime.getHours() + ':' + cTime.getMinutes() + ':' + cTime.getSeconds(),
            text: "System: " + this.getEmployeeName() + " " + action + " the ticket",
          };
          this.addComment(comment);
        },
        addComment(comment){
          axios
            .post(url + 'add-comment/',
              {data: comment},
              {
                withCredentials:'include',
                crossDomain:true
              })
            .then((response) => {
              if (response.data.error !== ''){
                if (response.data.error === 'Session is over'){
                  setCookie('Authentication','Failed',1);
                  this.$router.push('/login');
                }
                else{
                  this.notifyVue('danger',response.data.error);
                }
              }
              else{

              }
            });
        },
        getEmployeeName(){
          const employee = this.employees.filter(employee => parseInt(employee['employee_id']) === this.myEmployeeId);
          if (employee.length > 0){
            return employee[0]['first_name'] + " " + employee[0]['last_name'];
          }
          else{
            return "Employee Unknown"
          }
        },
      },
      created() {
        const urlParams = this.$route.query;
        this.getEmployees();
        this.isTickets = (this.tickets !== null);
        this.isEmployees = (this.employees !== null);
        let params = {};
        if (Object.entries(urlParams).length !== 0){
          if (urlParams.ticket_id        !== undefined) {params['ticket_id']        = urlParams.ticket_id;        }
          if (urlParams.employee_id_to   !== undefined) {params['employee_id_to']   = urlParams.employee_id_to;   }
          if (urlParams.employee_id_from !== undefined) {params['employee_id_from'] = urlParams.employee_id_from; }
          if (urlParams.done             !== undefined) {params['done']             = urlParams.done;             }
          if (urlParams.deleted          !== undefined) {params['deleted']          = urlParams.deleted;          }
          if (urlParams.is_read          !== undefined) {params['is_read']          = urlParams.is_read;          }
          if (urlParams.confirmed        !== undefined) {params['confirmed']        = urlParams.confirmed;        }
        }
        else{
          params = {
            is_read : "0",
          };
          const url = '#/tickets/?is_read=0';
          window.history.pushState("", "", url);
        }
        this.getTickets(params).then((response) =>{
          this.isTickets = (this.tickets !== null);
          this.showEmpty = true;
        });
        this.getEmployees().then((response) =>{
          this.isEmployees = (this.employees !== null);
        });
      },
    }
</script>

<style scoped>

</style>
